"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnalyticsData = void 0;
var _react = require("react");
var _context = require("../../context");
const useAnalyticsData = () => (0, _react.useContext)(_context.analyticsDataContext);
exports.useAnalyticsData = useAnalyticsData;
